(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gonz-atomizer-post-add"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('gonz-atomizer-post-add');

    if (!dialog || dialog.dataset.bound === 'true') {
      return;
    }

    dialog.dataset.bound = 'true';

    const addButton = dialog.querySelector('[data-gonz-atomizer-add]');
    const dismissButtons = dialog.querySelectorAll('[data-gonz-atomizer-dismiss]');
    const quantityInput = dialog.querySelector('[data-gonz-atomizer-quantity]');
    const decreaseButton = dialog.querySelector('[data-gonz-atomizer-decrease]');
    const increaseButton = dialog.querySelector('[data-gonz-atomizer-increase]');
    const status = dialog.querySelector('[role="status"]');
    const errorMessage = dialog.querySelector('[data-gonz-atomizer-error]').content.textContent.trim();
    const offerVariantId = String(dialog.dataset.offerVariantId);
    const unitPriceCents = Number(dialog.dataset.unitPriceCents);
    const currency = dialog.dataset.currency;
    const sessionKey = dialog.dataset.sessionKey;
    const excludedTitlePattern = /\b(decant|sample|vial|atomiser|atomizer|refillable|travel\s*spray|purse\s*spray|roller|discovery|miniature|mini\s*set)\b/i;
    let pendingVariantId = '';
    let pendingQualifying = false;
    let openingTimer;
    let autoPromptPending = false;

    const normalizeId = value => String(value || '').split('/').pop();
    const getQuantity = () => Math.max(1, Math.floor(Number(quantityInput.value) || 1));
    const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
      style: 'currency',
      currency
    }).format(cents / 100);
    const updateQuantityUi = () => {
      const quantity = getQuantity();

      quantityInput.value = quantity;
      decreaseButton.disabled = quantity <= 1;
      addButton.textContent = quantity === 1
        ? dialog.dataset.addSingleLabel
        : dialog.dataset.addMultipleTemplate
          .replace('__quantity__', quantity)
          .replace('__total__', formatMoney(unitPriceCents * quantity));
    };
    const itemQualifies = item => {
      if (!item || normalizeId(item.variant_id || item.id) === normalizeId(offerVariantId)) {
        return false;
      }

      const productType = String(item.product_type || '').trim().toLowerCase();
      const title = String(item.product_title || item.title || '');

      return productType === 'perfumes & fragrances' && !excludedTitlePattern.test(title);
    };

    const hasSeenPrompt = () => {
      try {
        return sessionStorage.getItem(sessionKey) === '1';
      } catch {
        return dialog.dataset.seen === 'true';
      }
    };

    const markPromptSeen = () => {
      dialog.dataset.seen = 'true';

      try {
        sessionStorage.setItem(sessionKey, '1');
      } catch {
        return;
      }
    };

    autoPromptPending = dialog.dataset.autoPrompt === 'true' && !hasSeenPrompt();

    const closeMiniCart = () => {
      const miniCart = document.getElementById('mini-cart');

      if (miniCart && miniCart.open) {
        miniCart.open = false;
      }
    };

    const cancelScheduledPrompt = () => {
      window.clearTimeout(openingTimer);
      openingTimer = undefined;
    };

    const schedulePrompt = delay => {
      cancelScheduledPrompt();
      openingTimer = window.setTimeout(() => {
        openingTimer = undefined;

        if (document.visibilityState === 'visible') {
          showPrompt();
        }
      }, delay);
    };

    const showPrompt = () => {
      if (dialog.open || hasSeenPrompt()) {
        return;
      }

      markPromptSeen();
      closeMiniCart();
      updateQuantityUi();
      document.documentElement.classList.add('gonz-atomizer-prompt-open');
      dialog.showModal();
      addButton.focus();
    };

    if (autoPromptPending) {
      const beginAutoPrompt = () => {
        if (!autoPromptPending) {
          return;
        }

        autoPromptPending = false;
        schedulePrompt(1500);
      };

      if (document.readyState === 'complete') {
        beginAutoPrompt();
      } else {
        window.addEventListener('load', beginAutoPrompt, { once: true });
      }
    }

    document.addEventListener('variant:added', event => {
      const variant = event.detail && event.detail.variant;
      const qualifier = event.target.closest('[data-gonz-atomizer-qualifier]');

      pendingVariantId = normalizeId(variant && (variant.variant_id || variant.id));
      pendingQualifying = qualifier ? qualifier.dataset.gonzAtomizerQualifier === 'true' : itemQualifies(variant);
    });

    document.documentElement.addEventListener('cart:refresh', event => {
      if (!pendingVariantId || hasSeenPrompt()) {
        return;
      }

      const cart = event.detail && event.detail.cart;

      if (!cart || !Array.isArray(cart.items)) {
        return;
      }

      const addedItem = cart.items.find(item => normalizeId(item.variant_id || item.id) === pendingVariantId);
      const qualifies = pendingQualifying || itemQualifies(addedItem);
      const atomizerInCart = cart.items.some(item => normalizeId(item.variant_id || item.id) === normalizeId(offerVariantId));

      pendingVariantId = '';
      pendingQualifying = false;

      if (!qualifies || atomizerInCart) {
        return;
      }

      const delay = window.matchMedia('(max-width: 740px)').matches ? 4000 : 3000;
      schedulePrompt(delay);
    });

    document.addEventListener('pointerdown', () => {
      if (!openingTimer && !autoPromptPending) {
        return;
      }

      autoPromptPending = false;
      cancelScheduledPrompt();
    }, true);

    document.addEventListener('keydown', event => {
      if ((!openingTimer && !autoPromptPending) || (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Escape')) {
        return;
      }

      autoPromptPending = false;
      cancelScheduledPrompt();
    }, true);

    document.addEventListener('wheel', () => {
      if (openingTimer || autoPromptPending) {
        autoPromptPending = false;
        cancelScheduledPrompt();
      }
    }, { capture: true, passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        autoPromptPending = false;
        cancelScheduledPrompt();
      }
    });

    dismissButtons.forEach(button => {
      button.addEventListener('click', () => dialog.close());
    });

    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('gonz-atomizer-prompt-open');
    });

    decreaseButton.addEventListener('click', () => {
      quantityInput.value = Math.max(1, getQuantity() - 1);
      updateQuantityUi();
    });

    increaseButton.addEventListener('click', () => {
      quantityInput.value = getQuantity() + 1;
      updateQuantityUi();
    });

    quantityInput.addEventListener('input', updateQuantityUi);
    quantityInput.addEventListener('change', updateQuantityUi);

    updateQuantityUi();

    addButton.addEventListener('click', async () => {
      const quantity = getQuantity();
      let succeeded = false;

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      addButton.textContent = addButton.dataset.loadingLabel;
      status.hidden = true;

      try {
        const addResponse = await fetch(dialog.dataset.cartAddUrl + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: Number(offerVariantId), quantity }],
            sections: ['mini-cart'],
            sections_url: window.location.pathname
          })
        });

        const addResult = await addResponse.json();

        if (!addResponse.ok) {
          throw new Error(addResult.description || errorMessage);
        }

        const cartResponse = await fetch(dialog.dataset.cartUrl + '.js', {
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        const cart = await cartResponse.json();

        cart.sections = addResult.sections;
        succeeded = true;
        status.textContent = quantity === 1
          ? dialog.dataset.successSingle
          : dialog.dataset.successMultipleTemplate.replace('__quantity__', quantity);
        status.hidden = false;
        addButton.textContent = status.textContent;

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart }
        }));

        await new Promise(resolve => window.setTimeout(resolve, 650));
        dialog.close();

        if (dialog.dataset.pageType === 'cart') {
          window.location.reload();
          return;
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart,
            openMiniCart: true
          }
        }));
      } catch (error) {
        status.textContent = error.message || errorMessage;
        status.hidden = false;
      } finally {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');

        if (!succeeded) {
          updateQuantityUi();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gonz-cart-atomizer-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-gonz-cart-atomizer-action]').forEach(action => {
      if (action.dataset.bound === 'true') {
        return;
      }

      action.dataset.bound = 'true';

      const form = action.closest('form');
      const input = action.querySelector('[data-gonz-cart-atomizer-quantity]');
      const decreaseButton = action.querySelector('[data-gonz-cart-atomizer-decrease]');
      const increaseButton = action.querySelector('[data-gonz-cart-atomizer-increase]');
      const submitButton = action.querySelector('[data-gonz-cart-atomizer-submit]');
      const unitPriceCents = Number(action.dataset.unitPriceCents);
      const currency = action.dataset.currency;
      const getQuantity = () => Math.max(1, Math.floor(Number(input.value) || 1));
      const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
        style: 'currency',
        currency
      }).format(cents / 100);
      const updateQuantityUi = () => {
        const quantity = getQuantity();

        input.value = quantity;
        decreaseButton.disabled = quantity <= 1;
        submitButton.textContent = quantity === 1
          ? action.dataset.addSingleLabel
          : action.dataset.addMultipleTemplate
            .replace('__quantity__', quantity)
            .replace('__total__', formatMoney(unitPriceCents * quantity));
      };

      decreaseButton.addEventListener('click', () => {
        input.value = Math.max(1, getQuantity() - 1);
        updateQuantityUi();
      });

      increaseButton.addEventListener('click', () => {
        input.value = getQuantity() + 1;
        updateQuantityUi();
      });

      input.addEventListener('input', updateQuantityUi);
      input.addEventListener('change', updateQuantityUi);
      form.addEventListener('submit', () => {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.loadingLabel;
      });

      updateQuantityUi();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gonz-nz-collection-header"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 699px)');
  const initialise = (root = document) => {
    root.querySelectorAll('[data-nz-collection-links]').forEach((shell) => {
      if (shell.dataset.ready === 'true') return;
      shell.dataset.ready = 'true';
      const track = shell.querySelector('[data-nz-collection-track]');
      const previous = shell.querySelector('[data-nz-collection-prev]');
      const next = shell.querySelector('[data-nz-collection-next]');
      if (!track) return;
      let timer = 0;
      const stop = () => {
        window.clearInterval(timer);
        timer = 0;
      };
      const move = (direction) => {
        const firstLink = track.querySelector('a');
        const step = firstLink ? firstLink.getBoundingClientRect().width : 132;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        const atStart = track.scrollLeft <= 8;
        if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (direction < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: direction * step, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      const start = () => {
        stop();
        if (mobile.matches && !reducedMotion.matches && track.scrollWidth > track.clientWidth) {
          timer = window.setInterval(() => move(1), 4200);
        }
      };
      previous?.addEventListener('click', () => {
        stop();
        move(-1);
        start();
      });
      next?.addEventListener('click', () => {
        stop();
        move(1);
        start();
      });
      ['pointerdown', 'touchstart', 'focusin'].forEach((eventName) => shell.addEventListener(eventName, stop, { passive: true }));
      shell.addEventListener('touchend', start, { passive: true });
      shell.addEventListener('focusout', (event) => {
        if (!shell.contains(event.relatedTarget)) start();
      });
      window.addEventListener('resize', start, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      reducedMotion.addEventListener?.('change', start);
      start();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gonz-relocation-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('gonz-relocation-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'gonz-relocation-popup-20261104';
  const remember = () => {
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
  };
  const wasSeen = () => {
    try { return sessionStorage.getItem(key) === '1'; } catch (error) { return false; }
  };
  const closeDialog = () => {
    remember();
    if (dialog.open) dialog.close();
  };
  dialog.querySelectorAll('[data-gonz-relocation-close]').forEach((button) => button.addEventListener('click', closeDialog));
  dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
  dialog.addEventListener('cancel', remember);
  if (!wasSeen()) requestAnimationFrame(() => dialog.showModal());
})();
  } catch(e) { console.error(e); }
})();

})();
